import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WarningTooltipModule } from '../WarningTooltip/warning-tooltip.module';
import { TogglerWithWarningComponent } from './toggler-with-warning.component';

export const TogglerWithWarningModuleExports = [TogglerWithWarningComponent];

@NgModule({
    imports: [CommonModule, WarningTooltipModule],
    declarations: [...TogglerWithWarningModuleExports],
    exports: [...TogglerWithWarningModuleExports],
    providers: []
})
export class TogglerWithWarningModule {}
